import price from "../assets/images/super-bg.webp";
import badge from "../assets/images/Most Popular.png";

export default function Pricing() {
  const plans = [
    {
      id: "1",
      bgType: "color",
      bgValue: "#190F2E",
      plan: "Basic",
      amount: "₦700",
      period: "weekly",
      features: [
        "6 uploads ",
        "7 Exam question predictions",
        "9 assignment solutions",
      ],
      button: "Choose Basic",
      badge: null,
    },

    {
      id: "2",
      bgType: "image",
      bgValue: price,
      plan: "Super",
      amount: "₦2,240 ",
      period: "monthly",
      features: [
        "Unlimited chats with Koye ",
        "28 Uploads",
        "15 Exam question predictions",
        "15 assignment solutions",
        " Access to better AI models",
      ],
      button: "Choose Super",
      badge: badge,
    },
    {
      id: "3",
      bgType: "color",
      bgValue: "#0C091A",
      plan: "Platinum",
      amount: "₦7,180 ",
      period: "monthly",
      features: [
        "Unlimited chats with Koye ",
        "35 Uploads",
        "18 Exam question predictions",
        "25 assignment solutions",
        " Access to the best AI models",
      ],
      button: "Choose Platinum",
      badge: null,
    },
  ];

  return (
    <div>
      <div className="container mt-[30px]">
        <h1 className="text-center">Pricing:</h1>
        <p className="text-center text-[20px] mt-[15px] mb-[60px]">
          Try Koye for free for 24 hours
        </p>
        <div className="flex justify-center  mb-[60px]">
          {" "}
          <h2 className=" inline px-9 py-3 font-normal bg-gradient-to-r from-purple to-darkPurple text-center rounded-[8px]">
            {" "}
            <strong>Launch Offer:</strong> 50% Off until /03/2026
          </h2>
        </div>
        <div className=" -mb-56 flex gap-[40px] max:md:justify-center  max-md:flex-col overflow-x-scroll sm:py-20 h-full">
          {plans.map((i) => (
            <div
              key={i.id}
              className={`rounded-3xl  mx-auto flex px-10 sm:px-16 flex-col relative transition-transform ${i.bgType === "image" ? "sm:-translate-y-[40px]" : ""} `}
              style={
                i.bgType === "image"
                  ? { backgroundImage: `url(${i.bgValue})` }
                  : { backgroundColor: i.bgValue }
              }
            
            >
              <div className="justify-between px-2  pt-[30px] pb-[20px] ">
                <p className="font-bold text-[24px]">{i.plan}</p>
                <div className="flex items-center mt-1 mb-5">
                  <p className="text-[28px]  ">{i.amount}</p>
                  <p className="text-[#6A6576] text-[18px]">{i.period}</p>
                </div>
                <ul className="list-inside space-y-2">
                  {i.features.map((feature) => (
                    <li className="list-disc" key={feature}>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <button className="text-white rounded-full border-2 border-white text-[12px] mb-[30px] w-60 whitespace-nowrap py-2 mt-auto hover:bg-purple duration-500 ease-in-out">
                {i.button}
              </button>
               {i.badge && (
        <div>
        <img
          src={i.badge}
          alt="badge"
          className="absolute -top-10 -right-5 z-20 "
        /></div>
      )}
            </div>
          ))}
        </div>
      </div>
     
    </div>
  );
}
